<template>
  <AuthLayout class="forgot-password-page">
    <div class="form-container">
      <AppLogo />
      <h2 class="title">Forgot Password</h2>

      <form @submit.prevent="sendLink" class="forgot-form">
        <InputField
          id="email"
          v-model="email"
          type="email"
          label="Email"
          placeholder="Enter your email"
          icon="fa-envelope"
          required
        />

        <AlertBox v-if="error"   :message="error"   variant="error" />
        <AlertBox v-if="success" :message="success" variant="success" />

        <button
          type="submit"
          class="send-button"
          :disabled="!isEmailValid || loading"
        >
          <span v-if="loading" class="loader"></span>
          <span v-else>Send Reset Link</span>
        </button>

        <div class="back-to-login">
          <router-link to="/login">Back to login</router-link>
        </div>
      </form>
    </div>
  </AuthLayout>
</template>

<script>
import axios       from 'axios';
import AuthLayout  from '@/components/AuthLayout.vue';
import AppLogo     from '@/components/AppLogo.vue';
import InputField  from '@/components/InputField.vue';
import AlertBox    from '@/components/Alert.vue';

export default {
  name: 'ForgotPassword',
  components: { AuthLayout, AppLogo, InputField, AlertBox },
  data() {
    return {
      email:   '',
      error:   '',
      success: '',
      loading: false
    };
  },
  computed: {
    // Simple email‐regex check
    isEmailValid() {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(this.email);
    }
  },
  methods: {
    async sendLink() {
      if (!this.isEmailValid || this.loading) return;
      this.error = this.success = '';
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/api/auth/forgot-password`,
          { email: this.email }
        );
        this.success = res.data.message;
      } catch (err) {
        this.error =
          err.response?.data?.error ||
          'Unable to send reset email. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* container spacing */
.form-container {
  max-width: 400px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* form layout */
.forgot-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* the “Send Reset Link” button */
.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 4px;
  background-color: var(--color-accent, #3b82f6);
  color: white;
  font-size: 1rem;
  font-weight: 600;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}

/* when disabled, still visible but semi-opaque */
.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* loader spinner */
.loader {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  vertical-align: middle;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* “Back to login” link style */
.back-to-login {
  text-align: center;
  margin-top: 0.5rem;
}
.back-to-login a {
  color: var(--color-accent);
  text-decoration: underline;
}
</style>
